import axios from 'axios'

export const useApi = () => {
  const opts = {
    headers: {
      common: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }
  }

  if (document.querySelector('meta[name="csrf-token"]')) {
    opts.headers['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').content
  }

  return axios.create(opts)
}
